import React, { Component, Fragment } from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import InvoiceDownload from './InvoiceDownload';
// import invoiceReport from '../reports/invoiceReport'


export class Datatable extends Component {
    
    constructor(props) {
        super(props)
        this.state = {
            checkedValues: [],
            myData: this.props.myData,
            selectedId: ""
        }
    }

    componentWillReceiveProps(props) {
        this.setState({ myData: props.myData })
    }

    selectRow = (e, i) => {
        if (!e.target.checked) {
            this.setState({
                checkedValues: this.state.checkedValues.filter((item, j) => i !== item)
            });
        } else {
            this.state.checkedValues.push(i);
            this.setState({
                checkedValues: this.state.checkedValues
            })
        }
         }

    // componentDidMount() {
    //     console.log(row.original.orderItems)
    // }

    handleRemoveRow = () => {
        const selectedValues = this.state.checkedValues;
        const updatedData = this.state.myData.filter(function (el) {
            return selectedValues.indexOf(el.id) < 0;
        });
        this.setState({
            myData: updatedData
        })
        toast.success("Successfully Deleted !")
    };

    renderEditable = (cellInfo) => {
        return (
            <div
                style={{ backgroundColor: "#fafafa" }}
                contentEditable
                suppressContentEditableWarning
                onBlur={e => {
                    const data = [...this.state.myData];
                    data[cellInfo.index][cellInfo.column.id] = e.target.innerHTML;
                    this.setState({ myData: data });
                }}
                dangerouslySetInnerHTML={{
                    __html: this.state.myData[cellInfo.index][cellInfo.column.id]
                }}
            />
        );
    }

    Capitalize(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
        }

    seeInvoice = (list) => {
        console.log(list)
        this.setState({ selectedId: list._id })
    }

    render() {
        const { pageSize, myClass, multiSelectOption, pagination } = this.props;
        const { myData } = this.state
        const columns = [];
        console.log(myData[0])
        for (var key in myData[0]) {


            let editable = null
            // let editable = this.renderEditable

            if (['_id'].includes(key)) {
                columns.push(
                    {
                        Header: <b>Invoice Number</b>,
                        accessor: key,
                        // Cell: editable,
                        Cell: (row) =>(
                            <div>
                                {row.original.invoiceId? row.original.invoiceId: "N.A"}
                            </div>
                        ),
                        style: {
                            textAlign: 'center'
                        }
                    });
            }
            if (['user'].includes(key)) {
                columns.push(
                    {
                        Header: <b>Courses</b>,
                        id: 'delete',
                        accessor: str => "delete",
                        Cell: (row) => (
                            <div>
                                {/* {row.original.orderItems.map((list, index) => { return (`${list.productId.name}${row.original.orderItems.length - 1 == index ? "" : ", "}`) })} */}
                                {row.original.orderItems.map((list, index) => { return row.original.orderItems[index].productId.name})
                                
                                }
                                {/* {row.original.orderItems.map((list, index) => { return [index].productId.name})} */}
                                {/* {row.original.orderItems[0].productId.name} */}
                            </div>
                        ),
                        style: {
                            textAlign: 'center'
                        },
                        sortable: false
                    }
                )
                columns.push(
                    {
                        Header: <b>Email</b>,
                        id: 'delete',
                        accessor: str => "delete",
                        Cell: (row) => (
                            <div>
                                {row.original.user ? row.original.email: "N.A"}
                            </div>
                        ),
                        style: {
                            textAlign: 'center'
                        },
                        sortable: false
                    }
                )
                columns.push(
                    {
                        Header: <b>Price</b>,
                        id: 'delete',
                        accessor: str => "delete",
                        Cell: (row) => (
                            <div>
                                {row.original.totalPrice}
                            </div>
                        ),
                        style: {
                            textAlign: 'center'
                        },
                        sortable: false
                    }
                )
                columns.push(
                    {
                        Header: <b>Status</b>,
                        id: 'delete',
                        accessor: str => "delete",
                        Cell: (row) => (
                            <div>
                                {row.original.isPaid==true ?
                                <button type="button" class="btn btn-success">Success</button>
                                  :
                                  row.original.offerFree==true ?
                                        <button type="button" class="btn btn-success">Free Course</button>
                                            :  
                                        <button type="button" class="btn btn-danger">Failed</button>
                                }

                            </div>
                        ),
                        style: {
                            textAlign: 'center'
                        },
                        sortable: false
                    }
                )
            }

        }

        if (multiSelectOption == true) {
            columns.push(
                {
                    Header: <button className="btn btn-danger btn-sm btn-delete mb-0 b-r-4"
                        onClick={
                            (e) => {
                                if (window.confirm('Are you sure you wish to delete this item?'))
                                    this.handleRemoveRow()
                            }}>Delete</button>,
                    id: 'delete',
                    accessor: str => "delete",
                    sortable: false,
                    style: {
                        textAlign: 'center'
                    },
                    Cell: (row) => (
                        <div>
                            <span >
                                <input type="checkbox" name={row.original.id} defaultChecked={this.state.checkedValues.includes(row.original.id)}
                                    onChange={e => this.selectRow(e, row.original.id)} />
                            </span>
                        </div>
                    ),
                    accessor: key,
                    style: {
                        textAlign: 'center'
                    }
                }
            )
        } else {
            columns.push(
                {
                    Header: <b>Action</b>,
                    id: 'delete',
                    accessor: str => "delete",
                    Cell: (row) => (
                        <div>
                            {row.original.isPaid==true || row.original.offerFree==true ? <button type="button" onClick={() => this.seeInvoice(row.original)} class="btn btn-primary">Invoice</button>
                                :
                                <button type="button" disabled class="btn btn-primary">Invoice</button>
                            }
                        </div>
                    ),
                    style: {
                        textAlign: 'center'
                    },
                    sortable: false
                }
            )
        }


        return (
            <Fragment>

                <ReactTable
                    data={myData}
                    columns={columns}
                    defaultPageSize={pageSize}
                    className={myClass}
                    showPagination={pagination}
                />
                <ToastContainer />
                
                {this.state.selectedId != "" ?
                    <div className="invoicePopup" style={{
                        position: "fixed", top: 0, left: 0, background: "white", zIndex: 11111, width: "100%", height: "100%"
                    }}>
                        <InvoiceDownload goBack={() => this.setState({ selectedId: "" })} id={this.state.selectedId} />
                    </div>
                    : null}
                    
            </Fragment>
        )
    }
}

export default Datatable
